/**
 * Reusable sx style objects.
 * Shared patterns so every component looks identical without duplication.
 */
import { C, F, G, SH } from './tokens';

/** MUI TextField consistent style */
export const fieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: C.bg,
    fontFamily: F.body,
    fontSize: 14,
    '& fieldset':             { borderColor: C.border },
    '&:hover fieldset':       { borderColor: C.blue },
    '&.Mui-focused fieldset': { borderColor: C.blue, borderWidth: 1.5 },
  },
  '& .MuiInputLabel-root':             { fontFamily: F.body, fontSize: 14 },
  '& .MuiInputLabel-root.Mui-focused': { color: C.blue },
};

/** Elevated white card with hover lift */
export const cardSx = {
  backgroundColor: C.white,
  border:          `1px solid ${C.border}`,
  borderRadius:    '18px',
  boxShadow:       SH.card,
  transition:      'box-shadow 0.25s, transform 0.25s',
  '&:hover': {
    boxShadow: SH.cardHover,
    transform: 'translateY(-4px)',
  },
};

/** Primary blue gradient button */
export const btnBlueSx = {
  background:  G.blue,
  color:       C.white,
  fontWeight:  700,
  fontFamily:  F.heading,
  borderRadius: '10px',
  boxShadow:   SH.btnBlue,
  '&:hover': { background: G.blueHover, boxShadow: SH.btnBlueHover },
  transition:  'all 0.2s ease',
};

/** Amber CTA button */
export const btnAmberSx = {
  backgroundColor: C.amber,
  color:           C.white,
  fontWeight:      700,
  fontFamily:      F.heading,
  borderRadius:    '8px',
  boxShadow:       SH.btnAmber,
  '&:hover': { backgroundColor: C.amberDark, boxShadow: SH.btnAmberHover },
  transition: 'all 0.2s ease',
};

/** Section outer padding */
export const sectionPx = { px: { xs: 2, md: 6 } };
export const sectionPy = { py: { xs: 7, md: 10 } };
